import { QChartTemplate } from "./QChartTemplate";
import { QRFC } from "./QRFC";

export class QChartTemplatesRFC extends QRFC {
  constructor() {
    super();
    this.singleSaveData = null;
  }

  InitUploadCTRFC(callbackObj) {
    this.InitRemoteCall(callbackObj, "POST", true, false);
    this.SetAllowStacked(true);
  }

  GetCallName() {
    return "qcharttemplates";
  }

  SetSingleSaveData(saveData) {
    this.singleSaveData = saveData;
  }

  SetParams(orgName, userName, mode, data) {
    this.AddParameter("data", data);
    this.AddParameter("mode", mode);
    this.AddParameter("org", orgName);
    this.AddParameter("user", userName);
  }

  DoTransactionComplete(response, callBackObj) {
    var r = JSON.parse(response);

    var success = r["success"];

    callBackObj.UploadChartTemplatesResult(success, this.singleSaveData);
  }
}
